import React from 'react';
import Icon from "../shared/Icon/Icon";

const IconItem = (props) => {
    return (
        <li className="benefit-icon" key={`${benefit?.key}-${index}`}>
            {props.fields?.icon && <Icon icon={props.fields.icon}/>}
            {props.fields?.text && <h3>{props.fields.text}</h3>}
        </li>
    );
};

export default IconItem;